import { envConfig } from '../../../env';
import { Post } from '@/service/request/server';

const baseApi = () => {
  function playerLogin(data) {
      return Post(`${envConfig.getCurrentApi()}/cotton/` + 'playerLogin', data);
  }

    function loginByPhone(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'loginByPhone', data);
    }

    function loginByEmail(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/loginByEmail', data);
    }

    function registerByEmail(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'web/registerByEmail', data);
    }

    function registerAccountByPhoneOrEmail(data) {
        return Post(`${envConfig.getCurrentApi()}/cotton/` + 'register', data);
    }

    {
        return {
            playerLogin,
            loginByPhone,
            loginByEmail,
            registerByEmail,
            registerAccountByPhoneOrEmail
        }
    }
}

export const loginApi = baseApi()
